import {Img, Heading} from "components";
import React from "react";

interface Props {
    className?: string;
    tabsNumber?: string;
    title?: string;
    description?: string;
    icon?: string;
}

export default  function ServicesTabs ({...props}) {
    return (
        <div
            {...props}
        className={`${props.className} rounded-[48px] md:rounded-[32px] sm:rounded-[32px] bg-[#ededed] w-full flex flex-col gap-20 md:gap-[48px] sm:gap-[48px]`}
        >
            <div className="mt-10 flex flex-col items-start gap-10 self-stretch px-10 sm:mt-6 sm:px-6">
                <Heading
                    size="desktop_heading_6"
                    className="font-normal test-[16px] leading-[100%] uppercase text-[#1B1F3BA6] ">
                    {props.tabsNumber}
                </Heading>
                <div className="flex flex-col items-start gap-4 self-stretch">
                    <Heading
                        size="desktop_heading_6"
                        className="text-[#191C30E5] uppercase leading-[120%]">
                        {props.title}
                    </Heading>
                    <Heading
                        size="desktop_body_l"
                        className="text-[#191C30E5] sm:hidden md:hidden">
                        {props.description}
                    </Heading>
                    <Heading
                        size="desktop_body_m"
                        className="text-[#191C30E5] lg:hidden">
                        {props.description}
                    </Heading>
                </div>
            </div>
            <div className=" flex justify-center self-stretch bg-[#333333] p-[54.5px] rounded-b-[48px]  md:rounded-b-[32px] sm:rounded-b-[32px] mt-auto h-[204px]">
                <Img
                    src={props.icon}
                    alt="icon"
                    className="object-contain relative"/>
            </div>
        </div>
    )
}